import {IntermediatePart} from "../../intermediatePart";

export default class PopoutWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'popout_wall';
    this.partName = 'Popout Wall';
    this.translateId = "visualizer.kitchen.walls.popout_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new PopoutWall());
  }

  setDefault() {
    if (!this.tryToSetTheSameFeature(this.features)) {
      const leftWall = this.getParent().leftWall;
      let sameWallAsLeftWall = null;
      if (leftWall && leftWall.activeFeature && leftWall.activeFeature.partName) {
        const leftWallName = leftWall.activeFeature.getSplittedFeatureName();
        sameWallAsLeftWall = this.features.find(wall => wall.getSplittedFeatureName() === leftWallName);
      }
      this.activeFeature = sameWallAsLeftWall || this.features[0]
    }
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Walls.PopoutWall;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
